<!--
 * @Author: DY
 * @Date: 2025-02-26 16:19:32
 * @LastEditTime: 2025-04-25 15:13:25
 * @Description: 多列表选择
 * @FilePath: \ShiMo_Mobile\src\components\selectList\index_many_list.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="listView commonListStyles">
            <van-nav-bar left-arrow :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div
                        v-for="(item, index) in parameter.pageTitle"
                        :key="`pageTitle_${index}`"
                        :class="{'active': parameter.titleIndex == index}"
                        @click="listSwitch(index)"
                    >
                        {{ item }}
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @search="onRefresh" @clear="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li
                                class="listItem"
                                v-for="(item, index) in listData"
                                :key="`item_${index}`"
                                :class="{ 'listItem_select': selectIDs.includes(item[parameter.relationKey]) }"
                                @click="selectList(item)"
                            >
                                <div class="engineeringInfo">
                                    <div class="itemContent">
                                        <template v-for="(k, j) in parameter.headerList[parameter.titleIndex]">
                                            <template v-if="k.isTitle">
                                                <p :key="`itemTerm_${j}`" class="itemTitle">
                                                    <van-icon class="selectIcon" name="checked"></van-icon>
                                                    <span>{{ k.name }}：{{ item[k.code] }}</span>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <p :key="`itemTerm_${j}`">
                                                    <img v-if="k.icon" :src="require(`@/assets/images/icons/${k.icon}.png`)">
                                                    <span>{{ k.name }}：{{ item[k.code] }}</span>
                                                </p>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <footer class="currencyFooterStyle">
                <button class="confirm" @click="confirmSelection">
                    确认选择
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
export default {
    name: 'list-view',
    components: {},
    data() {
        return {
            parameter: {
                pageTitle: ['选择列表'],
                titleIndex: 0,
                sourcePath: '/home',
                type: 'radio',
                listCode: [],
                indexKey: 'PageIndex',
                sizeKey: 'PageSize',
                SearchKey: 'SearchKey',
                pageIndex: 0,
                pageSize: 5,
                initIndex: 0,
                requestUrl: ['/basicplatform/tabledata'],
                requestType: 'post',
                headerList: [],
                tableList: [],
                callbackDataKey: '',
                relationKey: 'id',
                searchKey: 'searchKey',
            },
            keyVal: '',
            isUpLoading: false,
            isLoading: false,
            finished: false,
            listData: [],
            selectIDs: [],
        };
    },
    watch: {},
    created() {
        this.initPage();
    },
    mounted() {},
    computed: {},
    methods: {
        async initPage() {
            this.parameter = Object.assign(this.parameter, this.$route.params);
            this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        },
        listSwitch(index) {
            this.parameter.pageIndex = JSON.parse(JSON.stringify(this.parameter.initIndex));
            this.parameter.titleIndex = index;
            this.listData = [];
            this.finished = false;
            this.loadListData();
        },
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: this.parameter.sourcePath });
        },
        // 下拉刷新
        onRefresh() {
            this.parameter.pageIndex = JSON.parse(JSON.stringify(this.parameter.initIndex));
            this.listData = [];
            this.isLoading = false;
            this.finished = false;
            this.loadListData();
        },
        onLoad() {
            this.loadListData();
            this.parameter.pageIndex++;
        },
        loadRequestData() {
            return {
                cacheKey: this.cacheKey,
                code: this.parameter.listCode[this.parameter.titleIndex],
                [this.parameter.indexKey]: this.parameter.pageIndex,
                [this.parameter.sizeKey]: this.parameter.pageSize,
                [this.parameter.searchKey]: this.keyVal,
            };
        },
        selectList(item) {
            if (!this.selectIDs.includes(item[this.parameter.relationKey])) {
                if (this.parameter.type === 'radio') {
                    this.selectIDs = [item[this.parameter.relationKey]];
                } else {
                    this.selectIDs.push(item[this.parameter.relationKey]);
                }
            } else {
                const index = this.selectIDs.findIndex(k => k === item[this.parameter.relationKey]);
                this.selectIDs.splice(index, 1);
            }
        },
        confirmSelection() {
            const data = this.listData.filter(item => this.selectIDs.includes(item[this.parameter.relationKey]));
            if ((data || []).length > 0) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.parameter.sourcePath,
                    params: {
                        [this.parameter.callbackDataKey]: data,
                        code: this.parameter.listCode[this.parameter.titleIndex],
                    },
                });
            } else {
                this.$toast.fail('请先选择列表数据！');
            }
        },
        async loadListData() {
            if (this.parameter.requestType === 'post') {
                const requestData = this.loadRequestData();
                const res = await this.getListData_post(this.parameter.requestUrl[this.parameter.titleIndex], requestData);
                if (requestData[this.parameter.indexKey] === this.parameter.initIndex) {
                    this.listData = res.rows;
                } else {
                    this.listData.push(...res.rows);
                }
                if (res.total <= this.listData.length) {
                    this.finished = true;
                }
                this.isLoading = false;
                this.isUpLoading = false;
            } else if (this.parameter.requestType === 'get') {
                let requestUrl = this.parameter.requestUrl[this.parameter.titleIndex];
                if ((this.keyVal || '') !== '') {
                    if (this.parameter.requestUrl[this.parameter.titleIndex].includes('?')) {
                        requestUrl = `${this.parameter.requestUrl[this.parameter.titleIndex]}&${this.parameter.SearchKey}=${this.keyVal}`;
                    } else {
                        requestUrl = `${this.parameter.requestUrl[this.parameter.titleIndex]}?${this.parameter.SearchKey}=${this.keyVal}`;
                    }
                }
                const res = await this.getListData_get(requestUrl);
                this.listData = this.parameter.rowsKey && res ? res[this.parameter.rowsKey] : res;
                this.finished = true;
            }
        },
        getListData_post(requestUrl, requestData) {
            return this.$axios.$post(`/interfaceApi${requestUrl}`, requestData, { defEx: true });
        },
        getListData_get(requestUrl) {
            return this.$axios.$get(`/interfaceApi${requestUrl}`);
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.listView
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        .listItem
            &.listItem_select
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2), inset 0px 0px 20px 0px rgba(233,55,67,0.5);
                border: 1px solid #FF8C91 !important
                .itemTitle
                    border-bottom 1px solid #FFE8E9
                    .selectIcon
                        color #EA4651
        .engineeringInfo
            .itemContent
                padding 0 !important
            p
                padding 0 12rpx
                margin-bottom: 12rpx !important
                span
                    text-overflow: initial!important
                    white-space: initial!important
                    word-break: break-all;
                    height: auto!important
            .itemTitle
                margin: 0
                height 44rpx
                line-height 38rpx
                padding 6rpx 12rpx 0
                border-bottom 1px solid #E7E6E6
                display flex
                align-items: center
                .selectIcon
                    color #CACACA
                    font-size 18rpx
                    margin-right: 7rpx
</style>
